/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Timeline {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section, CmsImage } from "@bw/bits"
import { Timeline as TimelineModule } from "@bw/modules"

const Timeline = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  events,
  anchor,
}) => {
  if (!events || events.length === 0) {
    return null
  }

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition: buttonPosition?.value,
        anchor,
      }}
    >
      <TimelineModule
        events={events.map(event => ({
          ...event,
          image: <CmsImage src={event.image} alt="" />,
        }))}
      />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on TimelineModule {
 *   ...TimelineModuleFragment
 * }
 *
 * This is also what you will get in the props of your Timeline
 * resolver component.
 */
export const query = graphql`
  fragment TimelineModuleFragment on TimelineModule {
    events {
      period
      title
      description
      image {
        localImage {
          childImageSharp {
            gatsbyImageData(width: 800)
          }
        }
      }
    }
  }
`

export { Timeline }
